const headersElems = document.querySelectorAll(".click-menu__item-title");
const imagesElem = document.querySelectorAll(".click-menu__img-box");
const clickMenuListElem = document.querySelector(".click-menu__list");
clickMenuListElem.style.scrollBehavior = "smooth";

const headerElsArrLength = headersElems.length;
let currIdx = 1;

function isElemInViewport(el) {
  var rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function pointsIteration() {
  if (currIdx >= headerElsArrLength) {
    currIdx = 0;

    [...headersElems][0].classList.add("current");
    [...headersElems][headerElsArrLength - 1].classList.remove("current");

    [...imagesElem][0].classList.remove("!hidden");
    [...imagesElem][headerElsArrLength - 1].classList.add("!hidden");
  }

  [...headersElems][currIdx].classList.add("current");
  [...imagesElem][currIdx].classList.remove("!hidden");

  if (currIdx > 0) {
    [...headersElems][currIdx - 1].classList.remove("current");
    [...imagesElem][currIdx - 1].classList.add("!hidden");
  }

  currIdx++;
}

let interval;

if (window.innerWidth > 767) {
  interval = setInterval(pointsIteration, 10000);
}

/* on menu's point click */

[...headersElems].forEach((btn, btnIdx) => {
  btn.addEventListener("click", () => {
    if (window.innerWidth > 767) {
      currIdx = btnIdx + 1;
      clearInterval(interval);
      interval = setInterval(pointsIteration, 10000);
    }

    [...imagesElem].map((thumb, thumbIdx) => {
      if (btnIdx === thumbIdx) {
        thumb.classList.remove("!hidden");
        [...headersElems].forEach((button, buttonIdx) => {
          btnIdx === buttonIdx
            ? button.classList.add("current")
            : button.classList.remove("current");
        });
      } else {
        thumb.classList.add("!hidden");
      }
    });
  });
});

if (window.innerWidth < 768) {
  function scrollElementToCenterHorizontally(element) {
    console.log(element.parentElement, element.parentElement.offsetLeft - 20);

    clickMenuListElem.scrollLeft = element.parentElement.offsetLeft - 50;
  }

  function observeElement(element) {
    var threshold = 0.55;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio >= threshold) {
            element.click();
            scrollElementToCenterHorizontally(element);
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold,
      }
    );

    observer.observe(element);
  }
  [...headersElems].forEach(btn => {
    observeElement(btn);
  });
}
